module.exports = __webpack_public_path__ + "static/media/webSetting.3a46a45d.png";